module.exports = __webpack_public_path__ + "img/b_Forsmax_3.e99105ca.jpeg";